export const modifyAbilitazioneDatiInitialState = {
    buttonLoading: false,
    error: false
}

export const initialSegnalazioneState = {
    categoria: [],
    areas: [],
    dettaglio: [],
    referentes: []
}

export const initialReportProblemState = {
    loading: false,
    success: false,
    error: false
}

export const initialGestisciTagState = {
    loadingSim: false,
    loadingDevice: false
}

export const initialChangeRamGroup = {
    options: [],
    loading: false,
    buttonLoading: false,
    error: true
}